module.exports = __webpack_public_path__ + "assets/img/de-8e1f8ac1.png";